import HubspotIcon from '~/images/destinations/Hubspot.svg';
import SalesforceIcon from '~/images/destinations/Salesforce.svg';

import ConnectorSyncAlert from './ConnectorSyncAlert';
import styles from './styles';

const isInitialSync = (connector) => {
  const remoteMeta = connector.remoteMeta;

  return remoteMeta.isInitialSync && remoteMeta.syncStatus === 'syncing';
};

const getConnectorsByService = (connectors) => {
  let connectorsByService = {};
  if (connectors) {
    connectors.forEach((connector) => {
      if (isInitialSync(connector)) {
        connectorsByService[connector.service] = connector;
      }
    });
  }

  return connectorsByService;
};

const InitialSyncAlert = ({ classes, account }) => {
  if (!account || !account.connectors || !account.flags) {
    return null;
  }

  const connectorsByService = getConnectorsByService(account.connectors);
  let alerts = [];

  if (connectorsByService['salesforcesandbox']) {
    alerts.push(
      <ConnectorSyncAlert
        key="salesforce"
        name="Salesforce"
        icon={<SalesforceIcon />}
        accountConnector={connectorsByService['salesforcesandbox']}
      />,
    );
  }

  if (connectorsByService['salesforce']) {
    alerts.push(
      <ConnectorSyncAlert
        key="salesforce"
        name="Salesforce"
        icon={<SalesforceIcon />}
        accountConnector={connectorsByService['salesforce']}
      />,
    );
  }

  if (connectorsByService['hubspot']) {
    alerts.push(
      <ConnectorSyncAlert
        key="hubspot"
        name="HubSpot"
        icon={<HubspotIcon />}
        accountConnector={connectorsByService['hubspot']}
      />,
    );
  }

  if (!alerts.length) return null;

  return <div className={classes.syncAlertContainer}>{alerts}</div>;
};

InitialSyncAlert.propTypes = {
  classes: PropTypes.object,
  account: PropTypes.shape({
    connectors: PropTypes.array,
    flags: PropTypes.array,
  }),
};

export default withStyles(styles)(InitialSyncAlert);
